import styled from 'styled-components';

export const ManagerSignupContainer = styled.section`
  width: 100%;
  max-width: 820px;

  display: flex;
  flex-direction: column;
  gap: var(--space-l);

  margin: 0 auto;
`;

export const ManagerSignupHeader = styled.div`
  width: 100%;

  display: flex;
  align-items: flex-start;
  gap: var(--space-m);

  padding-bottom: var(--space-l);

  border-bottom: 1px solid var(--grey1);

  @media screen and (max-width: 600px) {
    gap: var(--space-s);
    padding-bottom: var(--space-m);
  }
`;

export const ManagerSignupIcon = styled.div`
  width: 46px;
  height: 46px;
  min-width: 46px;

  display: flex;
  align-items: center;
  justify-content: center;

  background: rgba(234, 154, 38, 0.1);
  color: var(--orange4);

  border-radius: 12px;

  svg {
    font-size: 1rem;
  }

  @media screen and (max-width: 600px) {
    width: 40px;
    height: 40px;
    min-width: 40px;

    border-radius: 10px;

    svg {
      font-size: 0.9rem;
    }
  }
`;

export const ManagerSignupHeaderContent = styled.div`
  min-width: 0;

  display: flex;
  flex-direction: column;
  gap: 0.25rem;

  > span {
    color: var(--orange4);

    font-size: 0.68rem;
    font-weight: 800;
    letter-spacing: 0.07em;
    line-height: 1.2;
    text-transform: uppercase;
  }

  h2 {
    margin: 0;

    color: var(--grey7);

    font-size: clamp(1.35rem, 2vw, 1.7rem);
    font-weight: 800;
    letter-spacing: -0.025em;
    line-height: 1.25;
  }

  p {
    max-width: 620px;

    margin: 0.15rem 0 0;

    color: var(--grey4);

    font-size: 0.85rem;
    line-height: 1.55;
  }

  @media screen and (max-width: 600px) {
    h2 {
      font-size: 1.2rem;
    }

    p {
      font-size: 0.78rem;
    }
  }
`;

export const ManagerSignupFields = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: var(--space-m);
`;

export const ManagerSignupFieldRow = styled.div`
  width: 100%;

  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--space-m);

  > * {
    min-width: 0;
  }

  @media screen and (max-width: 650px) {
    grid-template-columns: 1fr;
  }
`;

export const PasswordError = styled.p`
  margin: calc(var(--space-s) * -1) 0 0;

  color: #b42318;

  font-size: 0.75rem;
  font-weight: 650;
  line-height: 1.4;
`;

export const ManagerPreference = styled.div`
  width: 100%;

  display: flex;
  align-items: flex-start;
  gap: var(--space-s);

  margin-top: var(--space-xs);
  padding: var(--space-m);

  background: rgba(253, 220, 94, 0.08);

  border: 1px solid rgba(253, 220, 94, 0.3);
  border-radius: 12px;
`;

export const ManagerPreferenceCheckbox = styled.div`
  flex: 0 0 auto;

  padding-top: 0.1rem;

  input {
    position: absolute;

    width: 1px;
    height: 1px;

    opacity: 0;
    pointer-events: none;
  }

  span {
    width: 18px;
    height: 18px;

    display: flex;
    align-items: center;
    justify-content: center;

    background: var(--white);

    border: 1.5px solid var(--grey2);
    border-radius: 5px;

    cursor: pointer;

    transition:
      background 0.2s ease,
      border-color 0.2s ease;

    &::after {
      content: '';

      width: 8px;
      height: 4px;

      border-left: 2px solid var(--white);
      border-bottom: 2px solid var(--white);

      opacity: 0;

      transform: rotate(-45deg) translateY(-1px);
    }
  }

  input:checked + span {
    background: var(--orange4);
    border-color: var(--orange4);

    &::after {
      opacity: 1;
    }
  }

  input:focus-visible + span {
    outline: 2px solid var(--orange4);
    outline-offset: 2px;
  }
`;

export const ManagerPreferenceContent = styled.div`
  min-width: 0;

  display: flex;
  flex-direction: column;
  gap: 0.15rem;

  label {
    color: var(--grey7);

    font-size: 0.8rem;
    font-weight: 750;
    line-height: 1.4;

    cursor: pointer;
  }

  p {
    max-width: 650px;

    margin: 0;

    color: var(--grey4);

    font-size: 0.74rem;
    line-height: 1.5;
  }
`;

export const ManagerSignupActions = styled.div`
  width: 100%;

  display: flex;
  justify-content: flex-end;

  margin-top: var(--space-s);
  padding-top: var(--space-m);

  border-top: 1px solid var(--grey1);

  > div,
  > a {
    margin: 0;
  }

  @media screen and (max-width: 600px) {
    > div,
    > a,
    button {
      width: 100%;
    }
  }
`;
